import axios from "axios";

function getdataAsociadoDeduccion(data) {
    return axios.post('api/asociado-deduccion/dataAsociadoDeduccion', data).then(r => r.data).catch(r => r);
}

function getdataAsociadoDeduccionModal(data) {
    return axios.post('api/asociado-deduccion/dataAsociadoDeduccionModal', data).then(r => r.data).catch(r => r);
}

function guardarAsociadoDeduccion(data) {
    return axios.post('api/asociado-deduccion/guardarAsociadoDeduccion', data).then(r => r.data).catch(r => r);
}

function borrarAsociadoDeduccion(data) {
    return axios.post('api/asociado-deduccion/borrarAsociadoDeduccion', data).then(r => r.data).catch(r => r);
}

function updateAsociadoDeduccion(data){
    return axios.put('api/asociado-deduccion/updateAsociadoDeduccion', data).then(r => r.data).catch(r => r);
}


export {
    getdataAsociadoDeduccion,
    getdataAsociadoDeduccionModal,
    guardarAsociadoDeduccion,
    borrarAsociadoDeduccion,
    updateAsociadoDeduccion
}
